import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Input, Select, Spin, Button, Tag, Divider, AutoComplete } from 'antd';

import Translate from "../translate/Translate";
import MainTopNav from "./MainTopNav";
import RImage from '../static/resultDream-settings.png';
import IImage from '../static/resultDream-magnifier.png';
import AImage from '../static/resultDream-paint-palette.png';
import SImage from '../static/resultDream-conversation.png';
import EImage from '../static/resultDream-suitcase.png';
import CImage from '../static/resultDream-notes.png';
import field1 from '../static/resultDream-1.png';
import field2 from '../static/resultDream-2.png';
import field3 from '../static/resultDream-3.png';

import { translationResultGet } from "../../modules/translate";
import { mainpageJobGet, resultDreamDetailGet, resultDreamSearch } from "../../modules/result";

import {
    RightOutlined, LeftOutlined
} from '@ant-design/icons';
import MainFooter from './MainFooter';

const { Search } = Input;
const { Option } = Select;


class MainJob extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: null,
            allJob: null,
            selectedJob: null,
            resultJobDetail: null,
            filter: ["All"],
            jobOptions: [],
            currentJobOptions: []
        }
    }

    componentDidMount() {
        if (!this.state.title) {
            translationResultGet("main.jobSearch.search").then(
                (titleTranslation) => {
                    this.setState({ title: titleTranslation[this.props.language] })
                }
            )
        }
        // let jobNames = []
        if (!this.state.allJob) {
            mainpageJobGet().then(
                (data) => {
                    this.setState({ allJob: data })
                    let jobOptions = [];
                    data.results.forEach(element => {
                        jobOptions.push(
                            element.name.map(resultName => {
                                return {
                                    value: resultName.name
                                }
                            })
                        )
                    })
                    this.setState({ jobOptions })
                }
            )
        }
    }

    onSearch(value) {
        // console.log(value);
        resultDreamSearch(value).then(
            (data) => {
                this.setState({ allJob: data })
            }
        )
    }

    onSearchInput(value) {
        if (value.length >= 2) {
            this.setState({ currentJobOptions: this.state.jobOptions });
        }
        else {
            this.setState({ currentJobOptions: [] });
        }
    }

    handleJobSelectChange(value) {
        // console.log(value);
        if (value[0] == "All") {
            if (value.length > 1) {
                value.splice(0, 1)
                this.setState({ filter: value })
            }
            else {
                this.setState({ filter: ["All"] })
            }
        }
        else {
            if (value.includes("All")) {
                this.setState({ filter: ["All"] })
            }
            else {
                if (value.length > 0) {
                    this.setState({ filter: value })
                }
                else {
                    this.setState({ filter: [] })
                }
            }
        }

    }
    clearJobSelect(value) {
        this.setState({ filter: [] })
    }

    checkJob(target) {
        // console.log(target)
        this.setState({ selectedJob: target }, () => this.getDetail())

    }

    getDetail() {
        resultDreamDetailGet(this.state.selectedJob).then(
            (data) => {
                // console.log(data)
                this.setState({ resultJobDetail: data })
            }
        )
    }

    render() {
        const { allJob, selectedJob, resultJobDetail, filter, currentJobOptions } = this.state
        const image = { R: RImage, I: IImage, A: AImage, S: SImage, E: EImage, C: CImage };
        const hashtagcolour = ["magenta", "red", "volcano", "orange", "gold"]

        return (
            <div className="searchJob-container">
                <div className="static-banner">
                    <MainTopNav />
                    <div className="jobSearch-title"><Translate id="mian.jobSearch.title" /></div>
                    <AutoComplete
                        className="jobSearch-searchBar"
                        onChange={this.onSearchInput.bind(this)}
                        options={currentJobOptions}
                        filterOption={(inputValue, option) =>
                            option[0].value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }
                    ><Search placeholder={this.state.title} onSearch={this.onSearch.bind(this)} className="jobSearch-searchBar" enterButton /></AutoComplete>
                </div>
                <div className="jobSearch-main">

                    {
                        (!selectedJob) ?
                            <div>
                                <div className="jobSearch-jobType">
                                    <Translate id="main.jobSearch.jobType"></Translate>: &nbsp;
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        style={{ width: '100%' }}
                                        defaultValue={'All'}
                                        dropdownMatchSelectWidth={800}
                                        onChange={this.handleJobSelectChange.bind(this)}
                                        className="jobSearch-jobSelect"
                                        value={filter}
                                    >
                                        <Option key="All"><Translate id="type.all" /></Option>
                                        <Option key="R"><Translate id="type.R" /></Option>
                                        <Option key="I"><Translate id="type.I" /></Option>
                                        <Option key="A"><Translate id="type.A" /></Option>
                                        <Option key="S"><Translate id="type.S" /></Option>
                                        <Option key="E"><Translate id="type.E" /></Option>
                                        <Option key="C"><Translate id="type.C" /></Option>
                                    </Select>
                                </div>
                                <div className="jobSearch-jobOptions">
                                    {
                                        (allJob) ?
                                            (allJob.total > 0) ?
                                                <div className="resultDreamSearchRedirectFieldContainer">
                                                    {
                                                        allJob.results.map(
                                                            (jobData) => {
                                                                //console.log(jobData)
                                                                if (!filter.includes("All")) {
                                                                    if (filter.includes(jobData.code[0])) {
                                                                        return (
                                                                            <Button
                                                                                onClick={this.checkJob.bind(this, jobData["_id"])}
                                                                                type="primary" className={"mainJobBtn  resultDreamBtnColor"} key={jobData._id}>
                                                                                {jobData.name.map(
                                                                                    value => {
                                                                                        // console.log(value)
                                                                                        if (value.lang == this.props.language)
                                                                                            return (
                                                                                                value.name
                                                                                            )
                                                                                    }
                                                                                )
                                                                                }
                                                                                <RightOutlined className="resultBtnMore" />
                                                                            </Button>
                                                                        )
                                                                    }
                                                                }
                                                                else {
                                                                    return (
                                                                        <Button
                                                                            onClick={this.checkJob.bind(this, jobData["_id"])}
                                                                            type="primary" className={"mainJobBtn  resultDreamBtnColor"} key={jobData._id}>
                                                                            {jobData.name.map(
                                                                                value => {
                                                                                    // console.log(value)
                                                                                    if (value.lang == this.props.language)
                                                                                        return (
                                                                                            value.name
                                                                                        )
                                                                                }
                                                                            )
                                                                            }
                                                                            <RightOutlined className="resultBtnMore" />
                                                                        </Button>
                                                                    )
                                                                }
                                                            }
                                                        )
                                                    }
                                                    <p></p>
                                                </div>
                                                : <Translate id="resultDream.notfound" />
                                            : <div style={{ width: "80vw", display: "flex", justifyContent: "center" }}><Spin /></div>
                                    }
                                </div>
                            </div>

                            :
                            (resultJobDetail) ?
                                <div>
                                    <Button className="jobSearch-back" type="link" onClick={() => this.setState({ selectedJob: null })}><LeftOutlined /><Translate id="main.jobSearch.backSearch" /></Button>
                                    <div className="resultDreamDetailContainer">
                                        <div className="resultDreamDetailField resultDreamDetailTitle">
                                            {
                                                "tc" == this.props.language ? <span><bold>{resultJobDetail["name"][0]["name"]}</bold></span> : ""
                                            }
                                            {
                                                "en" == this.props.language ? <span><bold>{resultJobDetail["name"][1]["name"]}</bold></span> : ""
                                            }
                                            {
                                                "sc" == this.props.language && resultJobDetail["name"][2] != undefined ? <span><bold>{resultJobDetail["name"][2]["name"]}</bold></span> : ""
                                            }
                                            <span className={"resultDreamColor" + resultJobDetail["code"][0]}><img src={image[resultJobDetail["code"][0]]} className="resultDreamImg"></img><Translate id={"type." + resultJobDetail["code"][0]}></Translate></span>
                                        </div>
                                        <div className="resultDreamDetailField popuptextColor">
                                            <span><Translate id="resultDream.Intro"></Translate>:
                                                {resultJobDetail["career"].map(
                                                    (value) => {
                                                        // console.log(value)
                                                        if (value.lang == this.props.language)
                                                            return (value.description)
                                                    })
                                                }
                                            </span>
                                            <span className="resultDreamDetailTitle"><Translate id="resultDream.SDS"></Translate>:&nbsp;{resultJobDetail["code"]}</span>
                                        </div>

                                        <div className="resultDreamDetailDescriptionField">
                                            <div className="resultDreamDetailDescription">
                                                <div ><img src={field1} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title1"></Translate></div>
                                                {
                                                    resultJobDetail["description"].map(
                                                        (value) => {
                                                            // console.log(value)
                                                            if (value.lang == this.props.language) {
                                                                return value.descriptions.map(
                                                                    (descrip, index) => { return (<div className="popuptextColor resultDreamDetail">{index + 1}. {descrip}</div>) }
                                                                )
                                                            }
                                                        }
                                                    )
                                                }
                                            </div>
                                            <Divider type="vertical" />
                                            <div className="resultDreamDetailDescription">
                                                <div ><img src={field2} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title2"></Translate></div>
                                                {
                                                    resultJobDetail["character"].map(
                                                        (value) => {
                                                            // console.log(value)
                                                            if (value.lang == this.props.language) {
                                                                return value.characters.map(
                                                                    (descrip, index) => { return (<div className="popuptextColor resultDreamDetail">{index + 1}. {descrip}</div>) }
                                                                )
                                                            }
                                                        }
                                                    )
                                                }
                                            </div>
                                            <Divider type="vertical" />
                                            <div className="resultDreamDetailDescription">
                                                <div ><img src={field3} className="resultDreamTitleImg"></img><Translate id="resultDream.detail.title3"></Translate></div>
                                                {
                                                    resultJobDetail["requirement"].map(
                                                        (value) => {
                                                            // console.log(value)
                                                            if (value.lang == this.props.language) {
                                                                return value.requirements.map(
                                                                    (descrip, index) => { return (<div className="popuptextColor resultDreamDetail">{index + 1}. {descrip}</div>) }
                                                                )
                                                            }
                                                        }
                                                    )
                                                }
                                            </div>
                                        </div>

                                        <div style={{ padding: "5px 0" }}>
                                            <Translate id="resultDream.detail.title4"></Translate>:&nbsp;
                                            {
                                                resultJobDetail["hashTag"].map(
                                                    (value) => {
                                                        // console.log(value)
                                                        if (value.lang == this.props.language) {
                                                            return value.hashTags.map(
                                                                (hashTag, index) => { return (<Tag color={hashtagcolour[index]}># {hashTag}</Tag>) }
                                                            )
                                                        }
                                                    }
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                : <div style={{ width: "80vw", display: "flex", justifyContent: "center" }}><Spin /></div>
                    }
                </div>
                <MainFooter />
            </div>

        )
    }
}

const mapStateToProps = state => ({
    language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {

        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MainJob);
